import client from './client';

/**
 * 어뷰징 IP 클릭 통계 ( 어뷰징관리 )
 */
export const abusingIpReport = (param) =>
  client.get(`/api/report/abusing/ipreport`, param);

/**
 * 어뷰징 IP 클릭 통계 ( 어뷰징관리 )
 */
export const abusingIpReportClick = (param) =>
  client.get(`/api/report/abusing/ipreport/clickList`, param);

/**
 * 어뷰징 필터 통계 ( 어뷰징관리 )
 */
export const abusingFileReport = (param) =>
  client.get(`/api/report/abusing/filteripreport`, param);

/**
 * 통계보고서 - 어뷰징관리 - 컨버전 필터 광고주 수
 */
export const abusingFileReportCount = (param) =>
  client.get(`/api/report/abusing/filteripreport/count`, { params: param });

/**
 * 어뷰징 전환율 통계 ( 어뷰징관리 )
 */
export const abusingRateReport = (param) =>
  client.get(`/api/report/abusing/ratereport`, param);
/**
 * 어뷰징 전환율 평균구매액 광고주수
 */
export const abusingRateTotalCount = (param) =>
  client.get(`/api/report/abusing/avgreport/adverCnt`, { params: param });

/**
 * 어뷰징 전환율 통계 그래프 ( 어뷰징관리 )
 */
export const abusingRateGraph = (param) =>
  client.get(`/api/report/abusing/rategraph`, { params: param });

/**
 * 어뷰징 평균구매액 통계 ( 어뷰징관리 )
 */
export const abusingAvgReport = (param) =>
  client.get(`/api/report/abusing/avgreport`, param);

/**
 * 어뷰징 평균구매액 통계 그래프 ( 어뷰징관리 )
 */
export const abusingAvgGraph = (param) =>
  client.get(`/api/report/abusing/avggraph`, { params: param });

/**
 * 어뷰징 평균구매액 통계 그래프 ( 어뷰징관리 )
 */
export const cnvrsAbusingTpCodeList = () =>
  client.get(`/api/code/cnvrsAbusingTpCode`);

/**
 * 어뷰징 평균구매액 통계 그래프 ( 어뷰징관리 )
 */
export const abusingCountGraph = (params) =>
  client.get(`/api/report/abusing/filteripreport/countGraph`, {
    params: params,
  });
